import { Box, FormControl, styled, Typography, Select } from '@mui/material';

export const StyledFormControl = styled(FormControl)`
  width: 200px;
  text-align: left;
`;

export const StyledSelectContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 200px;
`;

export const StyledSelectLabel = styled(Typography)`
  color: ${({ theme }) => theme.palette.lightGrey.main};
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
`;

export const StyledSelect = styled(Select<string>)`
  height: 36px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white.main};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.primary.light};

  & .MuiSelect-select {
    display: block;
    padding: 6px 12px;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 24px;
    height: 36px !important;
    box-sizing: border-box;
    color: ${({ theme }) => theme.palette.primary.main};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }

  &.Mui-focused {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }
`;
